
export const useCollectionSearchStore = defineStore('collectionSearch', {
  state: () => ({
    collections: [],
    selectedCollection: 'all',
  }),
  actions: {
    setCollections(collections) {
      this.collections = [
        {
          id: 'all',
          name: 'Search All',
        },
        ...collections,
      ];
    },
    setSelectedCollection(collectionId) {
      this.selectedCollection = collectionId;
    },
  },
  getters: {
    query: (state) => {
      const {checkInDateISO, checkOutDateISO } = useCalendarPopover();
      if (state.selectedCollection === 'all') {
        return `/search?facility=${state.selectedCollection}&checkinDate=${checkInDateISO}${checkOutDateISO ? `&checkoutDate=${checkOutDateISO}` : ''}`
      }
      return `/search?collection=${state.selectedCollection}&checkinDate=${checkInDateISO}${checkOutDateISO ? `&checkoutDate=${checkOutDateISO}` : ''}`
    }
  },
  persist: {
    storage: piniaPluginPersistedstate.sessionStorage(),
  },
});
